import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import './floatingActions.css';

const FloatingActions = () => {
  const phoneNumber = "919876543210"; // Replace with your number (include country code)
  const whatsappMessage = "Hello! I have a query regarding your products.";

  return (
    <div className="floating-container">
      {/* WhatsApp Icon */}
      <a 
        href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(whatsappMessage)}`}
        className="floating-icon whatsapp"
        target="_blank" 
        rel="noopener noreferrer"
        title="Chat on WhatsApp"
      >
        <MessageCircle size={28} />
      </a>

      {/* Calling Icon */}
      <a 
        href={`tel:+${phoneNumber}`} 
        className="floating-icon calling"
        title="Call Us"
      >
        <Phone size={24} />
      </a>
    </div>
  );
};

export default FloatingActions;